import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { useCapabilities } from "store/capability-hooks";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsStudentPreview, selectQueryString } from "store/selectors";
import { viewStateActions } from "store/slices/view";
import { Link } from "utils/routing";

export const StudentPreview = () => {
  const dispatch = useAppDispatch();

  const queryString = useAppSelector(selectQueryString);
  const { canAuthorSection } = useCapabilities();
  const isStudentPreview = useAppSelector(selectIsStudentPreview);

  return (
    <>
      {isStudentPreview && (
        <SquareButton
          className="mt-4 w-full max-w-full justify-start"
          eventName="Account settings - Stop preview as a student"
          kind="tertiary"
          size="m"
          onClick={() => dispatch(viewStateActions.setIsStudentPreview(false))}
        >
          {t("profile_panel.stop_student_preview")}
        </SquareButton>
      )}

      {!isStudentPreview && canAuthorSection && (
        <SquareButton
          as={Link}
          className="mt-4 w-full max-w-full justify-start"
          eventName="Account settings - Preview as a student"
          kind="tertiary"
          size="m"
          to={{ pathname: ".", search: `?${queryString}&student=1` }}
          onClick={() => dispatch(viewStateActions.setIsStudentPreview(true))}
        >
          {t("section.sidebar.planner.preview_as_student")}
        </SquareButton>
      )}
    </>
  );
};
